import * as ExamApi from "@/api/exam/index";

const exam = {
  state: {
    examList: [],
    currentExamInfo: {},
    currentExamId: "",
  },

  mutations: {
    // 设置考试列表
    SET_EXAM_LIST(state, payload) {
      state.examList = payload;
    },
    // 设置当前考试信息
    SET_CURRENT_EXAM_INFO(state, payload) {
      state.currentExamInfo = payload;
    },
    // 设置考试id
    SET_CURRENT_EXAM_ID(state, payload) {
      state.currentExamId = payload;

      localStorage.setItem("currentExamId", state.currentExamId);
    },
  },

  actions: {
    fetchExamDataList({ commit }) {
      return new Promise((resolve, reject) => {
        // ExamApi.page({ status: 1 })
        ExamApi.page({ publishStatus: 1 })
          .then((res) => {
            commit("SET_EXAM_LIST", res.list);
            commit("SET_CURRENT_EXAM_ID", res.list[0]?.id || null);
             commit("SET_CURRENT_EXAM_INFO", res.list[0] || {});
            if (res.list.length == 0) {
              localStorage.removeItem("currentExamId");
            }
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchExamInfoById({ commit, state }) {
      return new Promise((resolve, reject) => {
        const examId = state.currentExamId;
        if (!examId || examId === "" || examId === "null") {
          return;
        }
        ExamApi.get({ id: examId })
          .then((res) => {
            commit("SET_CURRENT_EXAM_INFO", res);
            commit("SET_CURRENT_EXAM_ID", res.id);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default exam;
